import Check from "./bluecheck.png";
import Error from "./error.png";
import BE from "./be.png";
import IG from "./instagram.png";
import IG_STORY from "./instagramStory.png";
import FB from "./facebook.png";
import TW from "./twitter.png";
import LI from "./linkedin.png";
import TT from "./tik-tok.png";
import GL from "./google.png";
import ZL from "./zillow.png";
import IGLogo from "./instagramLogo.png";
import FBLogo from "./facebookLogo.png";
import TWLogo from "./twitterLogo.png";
import TTLogo from "./icTikTokSquare.png";
import LILogo from "./linkedInLogo.png";
import LIMedLogo from "./linkedinMed96.png";
import GLLogo from "./googleLogo.png";
import ZLLogo from "./zillowLogo.png";
import PreviewPhone from "./phoneFrame.png";
import Logo from "./logo.png";
import LogoWhite from "./logo_white.png";
import LogoCircleDark from "./logo_circle_dark.png";
import Profile from "./profile.png";
import iPhone15ProMax from "./iPhone15ProMax.png";
import dummyBanner from "./dummyBanner.png";

import ContentExample1 from "./contentExample1.png";
import ContentExample2 from "./contentExample2.png";
import ContentExample3 from "./contentExample3.png";
import ContentExample4 from "./contentExample4.png";
import ContentExample5 from "./contentExample5.png";
import ContentExample6 from "./contentExample6.png";

import BrandPostSuccess from "./brandPostSuccess.png";
import Experience from "./exp.png";
import InternalFeedback from "./internal.png";

export const Png = {
  BE,
  IG,
  FB,
  TW,
  LI,
  TT,
  GL,
  ZL,
  IG_STORY,
  IGLogo,
  FBLogo,
  TWLogo,
  LILogo,
  TTLogo,
  LIMedLogo,
  GLLogo,
  ZLLogo,
  PreviewPhone,
  Logo,
  Error,
  Check,
  Profile,
  iPhone15ProMax,
  dummyBanner,
  LogoWhite,
  LogoCircleDark,
  ContentExample1,
  ContentExample2,
  ContentExample3,
  ContentExample4,
  ContentExample5,
  ContentExample6,
  BrandPostSuccess,
  Experience,
  InternalFeedback,
};
